<nz-page-header nzTitle="Member List"></nz-page-header>

<a *ngIf="!employerId" [routerLink]="['/member/new']" nz-button nzType="dashed" class="mb-1">+ Onboard New Member</a>

<div class="row mt-3">
	<div class="col">
		<app-table [data]="data" [headerClass]="'table-info'" [columns]="columnRef" [filters]="filters"
			[loading]="loading" [disablePaging]="false" (onRowClick)="doView($event)"
			(onUpdateRequired)="doFetchResults($event)">
			<ng-template #givenNames let-row="row">
				<td>
					{{row.document.firstName??''}} {{row.document.secondName??''}} {{row.document.otherNames??''}}
				</td>
			</ng-template>
			<ng-template #viewable let-row="row">
				<td *ngIf="row.hasAccess == true">
					View
				</td>
				<td *ngIf="row.hasAccess == false">
					-
				</td>
			</ng-template>
			<ng-template #refDateOfDeath let-row="row">
				<td *ngIf="row.dateOfDeath">
					<nz-tag nzColor="red">{{row.dateOfDeath|date}}</nz-tag>
				</td>
			</ng-template>
		</app-table>
	</div>
</div>
